export const GoogleMapApiConfig = 'AIzaSyDxsEa51PHVALNoqCK7BS8E6hsYHiiqpQs';